interface Scripts {
    name: string;
    src: string;
}
export const ScriptStore: Scripts[] = [
    { name: 'jqx-grouping', src: 'assets/js/jqxgrid.grouping.js' },
    { name: 'jquery-min', src: 'plugins/jquery/jquery.min.js' },
    { name: 'bootstrap-bundle', src: 'plugins/bootstrap/js/bootstrap.bundle.min.js' },
    { name: 'overlayScrollbars', src: 'plugins/overlayScrollbars/js/jquery.overlayScrollbars.min.js' },
    { name: 'adminlte', src: 'plugins/js/adminlte.js' }
];